import {
    ArrowPathIcon,
    BoltIcon,
    ChatBubbleLeftRightIcon,
    PencilSquareIcon,
    PlayCircleIcon
} from '@heroicons/react/24/outline';
import type { ComponentType } from 'react';
import type { TaskActionItem } from './TaskActionsBox';

export type TxAction =
    'refinement' | 'retention' | 'manage-monitoring' | 'dm-notes' | 'messages' | 'open-vas';

const DM_NOT_LINKED_REASON = 'Patient must be created in Dental Monitoring first.';

interface TxActionSpec {
    action: TxAction;
    label: string;
    icon: ComponentType<{ className?: string }>;
    needsDm: boolean;
}

const TX_ACTIONS: readonly TxActionSpec[] = [
    { action: 'refinement', label: 'Trigger refinement', icon: ArrowPathIcon, needsDm: false },
    { action: 'retention', label: 'Trigger retention', icon: ArrowPathIcon, needsDm: false },
    { action: 'open-vas', label: 'Add VAs', icon: BoltIcon, needsDm: false },
    {
        action: 'manage-monitoring',
        label: 'Manage monitoring',
        icon: PlayCircleIcon,
        needsDm: true
    },
    { action: 'dm-notes', label: 'Edit DM notes', icon: PencilSquareIcon, needsDm: true },
    { action: 'messages', label: 'Patient messages', icon: ChatBubbleLeftRightIcon, needsDm: true }
];

// Manage Tx's tiles; the DM ones stay disabled until the patient exists in Dental Monitoring.
export function buildTxActionItems(
    isDmLinked: boolean,
    onTrigger: (action: TxAction) => void
): TaskActionItem[] {
    return TX_ACTIONS.map(({ action, label, icon, needsDm }) => {
        const blocked = needsDm && !isDmLinked;
        return {
            key: action,
            label,
            icon,
            disabled: blocked,
            disabledReason: blocked ? DM_NOT_LINKED_REASON : undefined,
            onSelect: () => {
                if (!blocked) onTrigger(action);
            }
        };
    });
}
